import type { Release } from '../../../types';

const toughLove: Release = {
  name: 'tough love',
  short_description: 'Melodic Tribute Release (Sailor & I Reinterpretation)',
  description:
    "An emotive electronic tribute by joev noise, reimagining Sailor & I's iconic composition into a driving, atmospheric journey. Propelled by soaring synth leads, lush harmonic progressions, and deep club-ready basslines, the track weaves nostalgic melancholy with uplifting dancefloor energy.",
  tracklist: [
    {
      trackname: 'tough love',
      duration: '5:40 min',
      tracknr: '01',
      directLink: {
        soundcloud: 'https://soundcloud.com/joevnoise/tough-love-joevnoise-sailorandi-tribute',
        spotify: 'https://joevnoise.page.link/spotify',
        bandcamp: 'https://joev.bandcamp.com/track/tough-love-sailor-i-tribute',
      },
    },
  ],
  date: '03-2020',
  bgColor: '#7eabcd',
  cover: 'joevnoise_tough-love.png',
  detail_link: 'tough-love',
  links: [
    {
      bandcamp: 'https://joev.bandcamp.com/track/tough-love-sailor-i-tribute',
    },
    {
      spotify: 'https://joevnoise.page.link/spotify',
    },
    {
      soundcloud: 'https://soundcloud.com/joevnoise/tough-love-joevnoise-sailorandi-tribute',
    },
  ],
};

export default toughLove;
